import { render } from "./FormularioPlanoConta.vue?vue&type=template&id=9a37ae9e&scoped=true"
import script from "./FormularioPlanoConta.vue?vue&type=script&lang=js"
export * from "./FormularioPlanoConta.vue?vue&type=script&lang=js"

import "./FormularioPlanoConta.vue?vue&type=style&index=0&id=9a37ae9e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a37ae9e"]])

export default __exports__